import React, { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from "react-select";
import { API_URL, API_URL_LOCAL } from "..";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import axios from "axios";
import { Spinner } from "react-bootstrap";

// Reusable Input Component
const FormInput = ({ label, name, type, value, onChange, error, required, placeholder }) => {
  if(label === 'PIN (4-digit)'){
    return(
      <div className="mb-20">
      <label className="form-label fw-semibold text-primary-light text-sm mb-8">
        {label} {required && <span className="text-danger-600">*</span>}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className="form-control radius-8"
        maxLength={4}
        placeholder={placeholder}
      />
      {error && <small className="text-danger-600">{error}</small>}
    </div>
    );
  }else{
    return(
      <div className="mb-20">
      <label className="form-label fw-semibold text-primary-light text-sm mb-8">
        {label} {required && <span className="text-danger-600">*</span>}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className="form-control radius-8"
        placeholder={placeholder}
      />
      {error && <small className="text-danger-600">{error}</small>}
    </div>
    );
  }
};

// Reusable Select Component
const FormSelect = ({ label, name, value, onChange, options, error, required }) => (
  <div className="mb-20">
    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
      {label} {required && <span className="text-danger-600">*</span>}
    </label>
    <Select
      name={name}
      value={options.find((opt) => opt.value === value) || null}
      onChange={(selected) => onChange({ target: { name, value: selected ? selected.value : "" } })}
      options={options}
      className="basic-single"
      classNamePrefix="select"
    />
    {error && <small className="text-danger-600">{error}</small>}
  </div>
);

const AddEmployeePage = () => {
  const [isLoaderActive, setIsLoaderActive] = useState(false)
  const [formValues, setFormValues] = useState({
    profile_image: null,
    first_name: "",
    last_name: "",
    username: "",
    password: "",
    pin: "",
    role: "",
    supervisor_name: "",
    hiring_date: "",
    department: "",
    location: "",
    employee_status: "",
    designation: "",
    working_model: "On Site",
    payout_type: "Monthly",
    amount: "",
    currency: "",
    payroll_cycle_date: "",
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [visitedSteps, setVisitedSteps] = useState([1]);
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });
  const [showModal, setShowModal] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState("");
  const [locationOptions, setLocationsOptions] = useState([])
  const [departmentOptions, setDepartmentOptions] = useState([])
  const [supervisorOptions, setSupervisorOptions] = useState([])
  const fetchLocations = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.id) {
        throw new Error("User not found in localStorage");
      }
      const response = await fetch(`${API_URL_LOCAL}/api/company/fetch/${user.id}`, {
        method: "GET",
      });
      if (!response.ok) throw new Error("Failed to fetch locations");
      const data = await response.json();
      if(response.status=== 200){
    
       const formated =  data.companies.map((e)=>({
          label: e.location,
          value:e.id
        }))
       
        setLocationsOptions(formated || []);
      }
    } catch (err) {
      // setError(err.message);
    } finally {
      // setLoading(false);
    }
  };
  useEffect(()=>{
    fetchLocations()
  },[1])
  

  
  const fetchDepartmentList = async (passed = null)=>{
    if(passed !== null){
      setFormValues((prev) => ({ ...prev, location: passed }))
    const apiCall = await fetch(API_URL_LOCAL+'/api/departments/fetch-by-location/'+passed , {method: 'GET'});
    const response = await apiCall.json();
    if(apiCall.status === 200){
      const formated =  response.departments.map((e)=>({
         label: e.name,
         value:e.id
       }))
       setDepartmentOptions(formated || []);
       const formatedSupervisor =  response.supervisor.map((e)=>({
         label: e.first_name + ' ' + e.last_name,
         value:e.id
        }))
        setSupervisorOptions(formatedSupervisor || []);
        
    }
  }
  }


  // Options for dropdowns
  const roleOptions = [
    { value: "", label: "--SELECT ROLE--" },
    { value: "admin", label: "Admin" },
    { value: "supervisor", label: "Supervisor" },
    { value: "user", label: "User" },
    { value: "driver", label: "Driver" },
  ];

  const statusOptions = [
    { value: "", label: "--SELECT STATUS--" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "probation", label: "Probation" },
  ];
  const currencyOptions = [
    { value: "", label: "--SELECT CURRENCY--" },
    { value: "USD", label: "USD" },
    { value: "PKR", label: "PKR" },
    { value: "EUR", label: "EUR" },
    { value: "GBP", label: "GBP" },
    { value: "JPY", label: "JPY" },
  ];
  const payrollCycleOptions = Array.from({ length: 31 }, (_, i) => ({
    value: `${i + 1}`,
    label: `${i + 1}`,
  }));
  const docTypeOptions = [
    { value: "medical_examination", label: "Medical Examination Certificate" },
    { value: "background_check", label: "Background Check Clearance" },
    { value: "drug_test", label: "Drug Test Results" },
    { value: "training_cert", label: "Training Certifications" },
  ];

  // Handle image preview
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormValues((prev) => ({ ...prev, profile_image: file }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  // Validation Logic
  const validateStep = useCallback(
    (step) => {
      const newErrors = {};
      const requiredFields = {
        1: ["first_name", "last_name", "username", "password", "pin"],
        2: ["role", "hiring_date", "department", "location", "employee_status", "designation"],
        3: ["payout_type", "amount", "currency", "payroll_cycle_date"],
      }[step] || [];

      requiredFields.forEach((field) => {
        if (!formValues[field]) {
          newErrors[field] = `${field
            .replace(/_/g, " ")
            .replace(/^\w/, (c) => c.toUpperCase())} is required`;
        }
      });

      if (step === 1) {
        if (formValues.pin && !/^\d{4}$/.test(formValues.pin)) {
          newErrors.pin = "PIN must be a 4-digit number";
        }
      }
      if (step === 3 && formValues.amount && Number(formValues.amount) <= 0) {
        newErrors.amount = "Amount must be greater than 0";
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    },
    [formValues]
  );

  // Navigation Handlers
  const handleNext = () => {
    if (validateStep(currentStep)) {
      const nextStep = currentStep + 1;
      setCurrentStep(nextStep);
      setVisitedSteps((prev) => [...new Set([...prev, nextStep])]);
      setErrors({});
    }
  };

  const handleBack = () => setCurrentStep((prev) => prev - 1);
  const handleStepClick = (step) => visitedSteps.includes(step) && setCurrentStep(step);

  // Document Handling
  const handleAddDocument = (e) => {
    const file = e.target.files[0];
    if (file && selectedDocType) {
      setDocuments((prev) => [...prev, { type: selectedDocType, file }]);
      setShowModal(false);
      setSelectedDocType("");
    }
  };

  const handleRemoveDocument = (index) => {
    setDocuments((prev) => prev.filter((_, i) => i !== index));
  };

  // Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoaderActive(true)
    const formData = new FormData();
    const user = JSON.parse(localStorage.getItem("user"));

    Object.entries(formValues).forEach(([key, value]) => {
      if (key !== "profile_image") {
        formData.append(key, value || "");
      }
    });
    if (formValues.profile_image) {
      formData.append("profile_image", formValues.profile_image);
    }
    documents.forEach((doc, index) => {
      formData.append("qualification_documents", doc.file); // all files under same field name
      formData.append("qualification_types[]", doc.type); // separate list of types
    });
    formData.append("org_id", user.id);
 

    try {
      const response = await axios.post(`${API_URL_LOCAL}/api/employee/register`,formData);
     
      await response.data;
      if(response.status === 201){
        setIsLoaderActive(false)
      setAlert({ show: true, type: "success", message: "Employee added successfully!" });
      setFormValues({
        profile_image: null,
        first_name: "",
        last_name: "",
        username: "",
        password: "",
        pin: "",
        role: "",
        supervisor_name: "",
        hiring_date: "",
        department: "",
        location: "",
        employee_status: "",
        designation: "",
        working_model: "On Site",
        payout_type: "Monthly",
        amount: "",
        currency: "",
        payroll_cycle_date: "",
      });
      setPreviewImage(null);
      setDocuments([]);
      setCurrentStep(1);
      setVisitedSteps([1]);
    }else{
      setIsLoaderActive(false)
      setAlert({ show: true, type: "error", message: response.data?.message });
      return false;
    }
    } catch (error) {
      setIsLoaderActive(false)
      setAlert({ show: true, type: "error", message: "Failed to submit form. Please try again." });
    }
  };

  // Step Line Component
  const StepLine = ({ currentStep, totalSteps = 4 }) => {
    const steps = [
      { id: 1, label: "Personal Info" },
      { id: 2, label: "Job Info" },
      { id: 3, label: "Payroll Info" },
      { id: 4, label: "Documents" },
    ];

    return (
      <div style={{ marginBottom: "24px", textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "relative" }}>
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <motion.div
                onClick={() => handleStepClick(step.id)}
                whileHover={visitedSteps.includes(step.id) ? { scale: 1.05 } : {}}
                style={{
                  cursor: visitedSteps.includes(step.id) ? "pointer" : "not-allowed",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  zIndex: 1,
                }}
              >
                <motion.div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    backgroundColor: step.id <= currentStep ? "#007bff" : "#d3d3d3",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                  animate={{ scale: step.id === currentStep ? 1.15 : 1 }}
                  transition={{ duration: 0.3 }}
                >
                  {step.id}
                </motion.div>
                <span style={{ fontSize: "12px", marginTop: "6px" }}>{step.label}</span>
              </motion.div>
              {index < steps.length - 1 && (
                <motion.div
                  style={{
                    height: "2px",
                    width: "50px",
                    backgroundColor: step.id < currentStep ? "#007bff" : "#d3d3d3",
                    position: "relative",
                    top: "-16px",
                  }}
                  initial={{ backgroundColor: "#d3d3d3" }}
                  animate={{ backgroundColor: step.id < currentStep ? "#007bff" : "#d3d3d3" }}
                  transition={{ duration: 0.5 }}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  };

  // Animation Variants
  const stepVariants = {
    hidden: { opacity: 0, x: 30 },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -30 },
  };

  const renderStep = () => {
    const stepsContent = {
      1: (
        <>
          <h6 className="mb-20">Personal Information</h6>
          <div className="mb-20">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
              Profile Image
            </label>
            <input
              type="file"
              name="profile_image"
              accept="image/*"
              onChange={handleImageChange}
              className="form-control radius-8"
            />
            {previewImage && (
              <div className="mt-10">
                <img
                  src={previewImage}
                  alt="Profile Preview"
                  style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px" }}
                />
              </div>
            )}
          </div>
          <FormInput
            label="First Name"
            name="first_name"
            type="text"
            value={formValues.first_name}
            onChange={(e) => setFormValues((prev) => ({ ...prev, first_name: e.target.value }))}
            error={errors.first_name}
            required
            placeholder="Enter First Name"
          />
          <FormInput
            label="Last Name"
            name="last_name"
            type="text"
            value={formValues.last_name}
            onChange={(e) => setFormValues((prev) => ({ ...prev, last_name: e.target.value }))}
            error={errors.last_name}
            required
            placeholder="Enter Last Name"
          />
          <FormInput
            label="Username"
            name="username"
            type="text"
            value={formValues.username}
            onChange={(e) => setFormValues((prev) => ({ ...prev, username: e.target.value }))}
            error={errors.username}
            required
            placeholder="Enter Username"
          />
          <FormInput
            label="Password"
            name="password"
            type="password"
            value={formValues.password}
            onChange={(e) => setFormValues((prev) => ({ ...prev, password: e.target.value }))}
            error={errors.password}
            required
            placeholder="Enter Password"
          />
          <FormInput
            label="PIN (4-digit)"
            name="pin"
            type="text"
            value={formValues.pin}
            onChange={(e) => setFormValues((prev) => ({ ...prev, pin: e.target.value }))}
            error={errors.pin}
            required
            placeholder="Enter 4-digit PIN"
          />
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={handleNext}
              className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
            >
              Next
            </button>
          </div>
        </>
      ),
      2: (
        <>
          <h6 className="mb-20">Job Information</h6>
          <FormInput
            label="Hiring Date"
            name="hiring_date"
            type="date"
            value={formValues.hiring_date}
            onChange={(e) => setFormValues((prev) => ({ ...prev, hiring_date: e.target.value }))}
            error={errors.hiring_date}
            required
          />
          <FormSelect
            label="Location"
            name="location"
            value={formValues.location}
            onChange={(e) => {
              
              fetchDepartmentList(e.target.value)
            }}
            options={locationOptions}
            error={errors.location}
            required
          />
           <FormSelect
            label="Department"
            name="department"
            value={formValues.department}
            onChange={(e) => setFormValues((prev) => ({ ...prev, department: e.target.value }))}
            options={departmentOptions}
            error={errors.department}
            required
          />
          <FormSelect
            label="Role"
            name="role"
            value={formValues.role}
            onChange={(e) => setFormValues((prev) => ({ ...prev, role: e.target.value }))}
            options={roleOptions}
            error={errors.role}
            required
          />
          <FormSelect
            label="Supervisor Name"
            name="supervisor_name"
            value={formValues.supervisor_name}
            onChange={(e) => setFormValues((prev) => ({ ...prev, supervisor_name: e.target.value }))}
            options={supervisorOptions}
            error={errors.supervisor_name}
          />
          
         
          <FormSelect
            label="Employee Status"
            name="employee_status"
            value={formValues.employee_status}
            onChange={(e) => setFormValues((prev) => ({ ...prev, employee_status: e.target.value }))}
            options={statusOptions}
            error={errors.employee_status}
            required
          />
          <FormInput
            label="Designation"
            name="designation"
            type="text"
            value={formValues.designation}
            onChange={(e) => setFormValues((prev) => ({ ...prev, designation: e.target.value }))}
            error={errors.designation}
            required
            placeholder="Enter Designation"
          />
          <div className="mb-20">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
              Working Model <span className="text-danger-600">*</span>
            </label>
            <div className="d-flex gap-3">
              {["On Site", "Remote"].map((mode) => (
                <div key={mode} className="form-check check-custom">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="working_model"
                    value={mode}
                    checked={formValues.working_model === mode}
                    onChange={(e) => setFormValues((prev) => ({ ...prev, working_model: e.target.value }))}
                  />
                  <label className="form-check-label">{mode}</label>
                </div>
              ))}
            </div>
          </div>
          <div className="d-flex justify-content-center gap-3">
            <button
              type="button"
              onClick={handleBack}
              className="btn btn-outline-primary text-md px-56 py-12 radius-8"
            >
              Back
            </button>
            <button
              type="button"
              onClick={handleNext}
              className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
            >
              Next
            </button>
          </div>
        </>
      ),
      3: (
        <>
          <h6 className="mb-20">Payroll Information</h6>
          <div className="mb-20">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
              Payout Type <span className="text-danger-600">*</span>
            </label>
            <div className="d-flex gap-3">
              {["Daily", "Hourly", "Monthly"].map((type) => (
                <div key={type} className="form-check check-custom">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="payout_type"
                    value={type}
                    checked={formValues.payout_type === type}
                    onChange={(e) => setFormValues((prev) => ({ ...prev, payout_type: e.target.value }))}
                  />
                  <label className="form-check-label">{type}</label>
                </div>
              ))}
            </div>
          </div>
          <FormInput
            label="Amount"
            name="amount"
            type="number"
            value={formValues.amount}
            onChange={(e) => setFormValues((prev) => ({ ...prev, amount: e.target.value }))}
            error={errors.amount}
            required
            placeholder="0.00"
          />
          <FormSelect
            label="Currency"
            name="currency"
            value={formValues.currency}
            onChange={(e) => setFormValues((prev) => ({ ...prev, currency: e.target.value }))}
            options={currencyOptions}
            error={errors.currency}
            required
          />
          <FormSelect
            label="Payroll Cycle Date"
            name="payroll_cycle_date"
            value={formValues.payroll_cycle_date}
            onChange={(e) => setFormValues((prev) => ({ ...prev, payroll_cycle_date: e.target.value }))}
            options={[{ value: "", label: "--SELECT DATE--" }, ...payrollCycleOptions]}
            error={errors.payroll_cycle_date}
            required
          />
          <div className="d-flex justify-content-center gap-3">
            <button
              type="button"
              onClick={handleBack}
              className="btn btn-outline-primary text-md px-56 py-12 radius-8"
            >
              Back
            </button>
            <button
              type="button"
              onClick={handleNext}
              className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
            >
              Next
            </button>
          </div>
        </>
      ),
      4: (
        <>
          <h6 className="mb-20">Documents (Optional)</h6>
          <div className="mb-20">
            <button
              type="button"
              className="btn btn-outline-primary text-md px-24 py-8 radius-8"
              onClick={() => setShowModal(true)}
            >
              Add Document
            </button>
          </div>
          {documents.length > 0 && (
            <div className="mb-20">
              <h6>Uploaded Documents</h6>
              {documents.map((doc, index) => (
                <div key={index} className="d-flex align-items-center justify-content-between mb-10">
                  <span>{docTypeOptions.find((opt) => opt.value === doc.type)?.label}</span>
                  <button
                    type="button"
                    className="text-danger-600"
                    onClick={() => handleRemoveDocument(index)}
                  >
                    <Icon fontSize={22} icon="iconamoon:sign-times-light" />
                  </button>
                </div>
              ))}
            </div>
          )}
          <div className="d-flex justify-content-center gap-3">
            <button
              type="button"
              onClick={handleBack}
              className="btn btn-outline-primary text-md px-56 py-12 radius-8"
            >
              Back
            </button>
            {
              isLoaderActive == true ?
              <Spinner/>:
            <button
              type="submit"
              className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
            >
              Submit
            </button>
            }
          </div>
        </>
      ),
    };

    return (
      <motion.div
        key={currentStep}
        variants={stepVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ duration: 0.3 }}
      >
        {stepsContent[currentStep]}
      </motion.div>
    );
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Add Employee" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <div className="row justify-content-center">
            <div className="col-xxl-6 col-xl-8 col-lg-10">
              <div className="card border">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <StepLine currentStep={currentStep} />
                    <AnimatePresence mode="wait">{renderStep()}</AnimatePresence>
                    {alert.show && (
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0 }}
                        className={`alert alert-${alert.type} bg-${alert.type}-50 text-${alert.type}-600 border-${alert.type}-50 px-24 py-11 mb-10 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between`}
                      >
                        {alert.message}
                        <button
                          type="button"
                          onClick={() => setAlert({ show: false, type: "", message: "" })}
                          className="text-secondary-600 text-xxl"
                        >
                          <Icon icon="iconamoon:sign-times-light" />
                        </button>
                      </motion.div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Modal style={{marginTop: 90}} show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title style={{fontSize : 22}}>
            <h6>Add Document</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormSelect
            label="Document Type"
            name="doc_type"
            value={selectedDocType}
            onChange={(e) => setSelectedDocType(e.target.value)}
            options={[{ value: "", label: "--SELECT DOCUMENT TYPE--" }, ...docTypeOptions]}
            required
          />
          {selectedDocType && (
            <div className="mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">Upload File</label>
              <input
                type="file"
                name="document_file"
                className="form-control radius-8"
                onChange={handleAddDocument}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      </div>

      {/* Document Modal */}
    </MasterLayout>
  );
};

export default AddEmployeePage;